export default __webpack_public_path__ + "static/grey-gravel-bananatex-b6bd18b1c31816ed3262190732031304.png";